@if (searchResultsLoaded$ | async) {
    <div class="cb-margin flex-col">
        <mat-card class="cb-margin-top">
            <mat-card-content>
                <form class="cb-margin-right-3x start-center flex-row">
                    <mat-icon class="cb-margin-right-2x">search</mat-icon>
                    <cb-input
                        class="cb-margin-right"
                        name="searchText"
                        label="Search"
                        [(ngModel)]="userCacheItem.data.query"
                    >
                    </cb-input>
                    <cb-select-list
                        class="cb-margin-right-2x"
                        label="Filter Quotes Status"
                        [allOptions]="quoteStatus"
                        [multiple]="true"
                        [value]="userCacheItem?.data?.statusIds"
                        (selectChanged)="userCacheItem.data.statusIds = $event.value"
                    >
                    </cb-select-list>
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="createQuoteMenu">
                        Create Quote
                    </button>
                    <mat-menu #createQuoteMenu="matMenu">
                        <button mat-menu-item (click)="createQuoteRequired()">
                            <span>Quote Required</span>
                        </button>
                        <button mat-menu-item (click)="createQuoteReceived()">
                            <span>Quote Received</span>
                        </button>
                    </mat-menu>
                    <span class="flex"></span>
                    <button
                        mat-icon-button
                        (click)="toggeleColumnWitdh()"
                        [disabled]="quotedSpecItems.length < 1"
                    >
                        <mat-icon>{{
                            showSpecificationItemsPanel ? 'arrow_forward' : 'menu'
                        }}</mat-icon>
                        <span class="counter">{{ quotedSpecItems.length }}</span>
                    </button>
                </form>
            </mat-card-content>
        </mat-card>
        <div class="flex-row">
            <div
                #scrollContainer
                class="cb-margin-top lot-quotes-scroller flex"
                [ngClass]="'flex-' + mainPanelWidth"
            >
                <div
                    class="flex-wrap"
                    infiniteScroll
                    (scrolled)="doSearch()"
                    [immediateCheck]="false"
                    [fromRoot]="true"
                    [infiniteScrollContainer]="scrollContainer"
                >
                    @for (item of searchResults; track item) {
                        <cb-lot-quote-card
                            class="quote-list-item xl-33 md-100 lg-50 sm-100 xs-100"
                            [lotQuoteSearchItem]="item"
                            [isLotSpecLocked]="lotMappedItem.lotSpecLocked"
                            [lotMappedItem]="lotMappedItem"
                            (quoteDuplicated)="quoteDuplicated($event)"
                            (refreshSearch)="loadSearchParams()"
                        >
                            {{ item.quoteNumber }}
                        </cb-lot-quote-card>
                    }
                    @if (searchResults?.length < 1) {
                        <cb-info-message message="There were no Quotes found"> </cb-info-message>
                    }
                </div>
            </div>
            @if (showSpecificationItemsPanel) {
                <div class="flex" [ngClass]="'flex-' + sidePanelWidth">
                    <mat-list>
                        <div mat-subheader>Quoted Specification Items</div>
                        @for (specItem of quotedSpecItems; track specItem) {
                            <mat-list-item>
                                <div matListItemTitle cbEllipsis>
                                    {{
                                        specItem.originalCostType | cbEnumToLabel: COST_TYPE_ENUM
                                    }}
                                    -
                                    {{ specItem.productDisplay }}
                                </div>
                                <div class="flex-row currency-line" matListItemLine>
                                    <span>{{ specItem.rate | cbCurrency }} </span>
                                    <span class="flex"></span>
                                    <span
                                        >Amount Spent:&nbsp;{{
                                            specItem.amountSpent | cbCurrency
                                        }}</span
                                    >
                                </div>
                                <mat-divider class="custom-divider" [inset]="true"></mat-divider>
                            </mat-list-item>
                        }
                    </mat-list>
                </div>
            }
        </div>
    </div>
}
@if (!searchResultsLoaded) {
    <cb-loading-spinner></cb-loading-spinner>
}
